import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query fetchGroupCategories($page: Int!, $limit: Int!, $sort: String!) {
    groupCategories(
      limit: $limit
      page: $page
      sort: $sort,
    ) {
      totalDocs
      totalPages
      docs {
        id
        name
      }
    }
  }
`

export enum GroupCategoriesSort {
  NameAsc = 'name',
  NameDesc = '-name',
}

export interface GroupCategoriesInput {
  page?: number
  limit?: number
  sort: GroupCategoriesSort
}

export interface GroupCategoriesOutput {
  groupCategories: {
    totalDocs: number
    totalPages: number
    docs: {
      id: string
      name: string
    }[]
  }
}

const defaultVariables: GroupCategoriesInput = {
  page: 1,
  limit: 100,
  sort: GroupCategoriesSort.NameAsc,
}

export const useGroupCategoriesQuery = (options?: QueryHookOptions<GroupCategoriesOutput, GroupCategoriesInput>) =>
  usePersistedCacheQuery<GroupCategoriesOutput, GroupCategoriesInput>(query, {
    variables: defaultVariables,
    ...options,
  })

export const groupsCategoriesQuery = { query, defaultVariables }
